/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const ErrorNoIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8334 12C18.8334 15.7739 15.774 18.8333 12 18.8333C10.4657 18.8333 9.04953 18.3277 7.90901 17.4739L17.4739 7.90898C18.3277 9.0495 18.8334 10.4657 18.8334 12ZM6.81295 16.4486L16.4487 6.81292C15.2532 5.78673 13.699 5.16666 12 5.16666C8.22607 5.16666 5.16669 8.22604 5.16669 12C5.16669 13.699 5.78676 15.2532 6.81295 16.4486ZM20.3334 12C20.3334 16.6024 16.6024 20.3333 12 20.3333C7.39765 20.3333 3.66669 16.6024 3.66669 12C3.66669 7.39762 7.39765 3.66666 12 3.66666C16.6024 3.66666 20.3334 7.39762 20.3334 12Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
